import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import projectService from '../../services/projectService';
import './ProjectList.css';
import CommonModal from '../../services/CommonModal';

const ProjectList = ({ selectionMode = false, onSelect }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: '',
    priority: '',
    search: '',
    page: 1,
    limit: 20
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [pagination, setPagination] = useState({});
  const [selectedProject, setSelectedProject] = useState(null);


  const confirmDelete = () => {
    console.log("uuuu")
    handleDelete(selectedProject.id);
    setShowDeleteModal(false);
  };


  useEffect(() => {
    fetchProjects();
  }, [filters]);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const data = await projectService.getAllProjects(filters);
      setProjects(data.projects || []);
      setPagination(data.pagination || {});
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch projects');
      setProjects([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    // if (!window.confirm('Are you sure you want to delete this project?')) {
    //   return;
    // }

    try {
      await projectService.deleteProject(id);
      fetchProjects();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete project');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const handleProjectSelect = (project) => {
    if (selectionMode && onSelect) {
      setSelectedProject(project);
      onSelect(project);
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      'Planning': 'badge-secondary',
      'In Progress': 'badge-primary',
      'On Hold': 'badge-warning',
      'Completed': 'badge-success',
      'Cancelled': 'badge-danger'
    };
    return statusColors[status] || 'badge-secondary';
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      'Low': 'badge-info',
      'Medium': 'badge-warning',
      'High': 'badge-danger',
      'Critical': 'badge-danger-dark'
    };
    return priorityColors[priority] || 'badge-secondary';
  };
  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  if (loading && projects.length === 0) {
    return <div className="loading">Loading projects...</div>;
  }

  return (
    <div className="project-list-container">
      {!selectionMode && (
        <div className="project-list-header">
          <h1>Projects</h1>
          <Link to="/app/projects/new" className="btn btn-primary">
            <i className="fas fa-plus"></i> Create Project
          </Link>
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete project"
        message="Are you sure you want to delete this project?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedProject(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />

      <div className="filters filter-custom">
        <div className="filter-group">
          <input
            type="text"
            name="search"
            placeholder="Search projects..."
            value={filters.search}
            onChange={handleFilterChange}
            className="form-control filter-custom"
          />
        </div>
        <div className="filter-group">
          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Status</option>
            <option value="Planning">Planning</option>
            <option value="In Progress">In Progress</option>
            <option value="On Hold">On Hold</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>
        <div className="filter-group">
          <select
            name="priority"
            value={filters.priority}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Priority</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>
        </div>
      </div>

      <div className="project-list">
        {!projects || projects.length === 0 ? (
          <div className="no-projects">
            <p>No projects found</p>
            {!selectionMode && (
              <Link to="/app/projects/new" className="btn btn-primary">Create your first project</Link>
            )}
          </div>
        ) : (
          <div className="projects-grid">
            {projects.map(project => (
              <div
                key={project.id}
                className={`project-card ${selectionMode && selectedProject?.id === project.id ? 'selected' : ''}`}
                onClick={() => selectionMode && handleProjectSelect(project)}
              >
                <div className="project-card-header">
                  <div className="project-info">
                    <h3>
                      {selectionMode ? (
                        project.name
                      ) : (
                        <Link to={`/app/projects/${project.id}`}>{project.name}</Link>
                      )}
                    </h3>
                    <span className="project-code">{project.code}</span>
                  </div>
                  <div className="project-badges">
                    <span className={`badge ${getStatusBadge(project.status)}`}>
                      {project.status}
                    </span>
                    <span className={`badge ${getPriorityBadge(project.priority)}`}>
                      {project.priority}
                    </span>
                  </div>
                </div>

                <div className="project-card-body">
                  {/* <p className="project-description">{project.description}</p> */}

                  <div
                    className="project-description"
                    dangerouslySetInnerHTML={{ __html: project.description }}
                  />

                  <div className="project-meta">
                    {project.project_manager && (
                      <div className="meta-item">
                        <i className="fas fa-user"></i>
                        <span>{project.project_manager.first_name} {project.project_manager.last_name}</span>
                      </div>
                    )}
                    {project.start_date && (
                      <div className="meta-item" title="Start Date">
                        <i className="fas fa-calendar"></i>
                        <span> {formatDate(project.start_date)}</span>
                      </div>
                    )}
                  </div>

                  <div className="project-progress">
                    <div className="progress-header">
                      <span>Progress</span>
                      <span>{project.progress_percentage}%</span>
                    </div>
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${project.progress_percentage}%` }}
                      ></div>
                    </div>
                  </div>

                  {project.budget_allocated && (
                    <div className="project-budget">
                      <div className="budget-item">
                        <span className="budget-label">Budget:</span>
                        <span className="budget-value">₹{project.budget_allocated.toLocaleString()}</span>
                      </div>
                      <div className="budget-item">
                        <span className="budget-label">Spent:</span>
                        <span className="budget-value">₹{project.budget_spent.toLocaleString()}</span>
                      </div>
                    </div>
                  )}
                </div>

                {!selectionMode && (
                  <div className="project-card-footer">
                    <Link
                      to={`/app/projects/${project.id}/edit`}
                      className="btn btn-sm btn-outline-primary"
                    >
                      <i className="fas fa-edit"></i> Edit
                    </Link>
                    <button
                      onClick={(e) => {
                        setShowDeleteModal(true);
                        setSelectedProject(project)
                      }}
                      className="btn btn-sm btn-outline-danger"
                    >
                      <i className="fas fa-trash"></i> Delete
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {pagination.pages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
            disabled={filters.page === 1}
            className="btn btn-outline-primary"
          >
            Previous
          </button>
          <span className="page-info">
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
            disabled={filters.page === pagination.pages}
            className="btn btn-outline-primary"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectList;


